import React, { Component, useState, useEffect, useRef, useCallback } from 'react';
import { fabric } from 'fabric';

import Range from '../toolbar/common/Range'

const SLIDERS = [
  {
    type: "separator",
  },
  {
    attribute: "temperature",
    name: "Temp",
    min: -100,
    max: 100,
    step: 1
  },
  {
    attribute: "tint",
    name: "Tint",
    min: -100,
    max: 100,
    step: 1
  },
  {
    type: "separator"
  },
  {
    attribute: "exposure",
    name: "Exposure",
    min: -5,
    max: 5,
    step: 0.05
  },
  {
    attribute: "contrast",
    name: "Contrast",
    min: -100,
    max: 100,
    step: 1
  },
  {
    type: "separator"
  },
  {
    attribute: "highlights",
    name: "Highlights",
    min: -100,
    max: 100,
    step: 1
  },
  {
    attribute: "shadows",
    name: "Shadows",
    min: -100,
    max: 100,
    step: 1
  },
  {
    attribute: "whites",
    name: "Whites",
    min: -100,
    max: 100,
    step: 1
  },
  {
    attribute: "blacks",
    name: "Blacks",
    min: -100,
    max: 100,
    step: 1
  },
  {
    type: "separator"
  },
  {
    attribute: "vibrance",
    name: "Vibrance",
    min: -100,
    max: 100,
    step: 1
  },
  {
    attribute: "saturation",
    name: "Saturation",
    min: -100,
    max: 100,
    step: 1
  },
  {
    type: "separator",
    name: "Grain"
  },
  {
    attribute: "grainAmount",
    name: "Amount",
    min: 0,
    max: 100,
    step: 1
  },
  {
    attribute: "grainSize",
    name: "Size",
    min: 0,
    max: 100,
    step: 1
  },
  {
    attribute: "grainRoughness",
    name: "Roughness",
    min: 0,
    max: 100,
    step: 1
  },
]

const ADJUSTMENT_SLIDERS = [

    {
      type: "separator",
      name: "Hue",
    },

    {
      attribute: "redHueAdjustment",
      name: "Red",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "orangeHueAdjustment",
      name: "Orange",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "yellowHueAdjustment",
      name: "Yellow",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "greenHueAdjustment",
      name: "Green",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "aquaHueAdjustment",
      name: "Aqua",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "blueHueAdjustment",
      name: "Blue",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "purpleHueAdjustment",
      name: "Purple",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "magentaHueAdjustment",
      name: "Magenta",
      min: -100,
      max: 100,
      step: 1
    },

    {
      type: "separator",
      name: "Saturation",
    },

    {
      attribute: "redSaturationAdjustment",
      name: "Red",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "orangeSaturationAdjustment",
      name: "Orange",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "yellowSaturationAdjustment",
      name: "Yellow",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "greenSaturationAdjustment",
      name: "Green",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "aquaSaturationAdjustment",
      name: "Aqua",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "blueSaturationAdjustment",
      name: "Blue",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "purpleSaturationAdjustment",
      name: "Purple",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "magentaSaturationAdjustment",
      name: "Magenta",
      min: -100,
      max: 100,
      step: 1
    },

    {
      type: "separator",
      name: "Luminance",
    },

    {
      attribute: "redLuminanceAdjustment",
      name: "Red",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "orangeLuminanceAdjustment",
      name: "Orange",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "yellowLuminanceAdjustment",
      name: "Yellow",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "greenLuminanceAdjustment",
      name: "Green",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "aquaLuminanceAdjustment",
      name: "Aqua",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "blueLuminanceAdjustment",
      name: "Blue",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "purpleLuminanceAdjustment",
      name: "Purple",
      min: -100,
      max: 100,
      step: 1
    },
    {
      attribute: "magentaLuminanceAdjustment",
      name: "Magenta",
      min: -100,
      max: 100,
      step: 1
    },
]
const FilterEditor = (props) => {
  let {
    filter,
    onUpdated
  } = props

  const handleCopyClick = () => {
    const filterValues = filter.data || {};

    const filteredValues = Object.fromEntries(
      Object.entries(filterValues).filter(([key, value]) => value != 0)
    );

    let filterString = ""
    Object.entries(filterValues).map((val) => {
      if(val[0] == "type" || val[1] == 0){
        return
      }
      else if(val[0] == "grainSeed" || val[0] == "name"){
        return
      }
      filterString += `this.${val[0]} = ${val[1]}\n`
    })
    navigator.clipboard.writeText(filterString);
    alert("Text Copied")
  };


  const renderSlider = (slider, index) => {
    if(slider.type === "separator"){
      return (
        <div key={index} className="mt-3">
          <b>{slider.name}</b>
        </div>
      )
    }
    let data = filter.data || {}

    return (
      <div key={slider.attribute} className="row">
        <div className="col-4">
          {slider.name}
        </div>
        <div className="col-6">
          <Range
            value={data[slider.attribute]}
            min={slider.min}
            max={slider.max}
            step={slider.step}
            onChange={(e) => {
              data[slider.attribute] = parseFloat(e.target.value)
              filter.data = data
              onUpdated(filter)
            }}
          />
        </div>
        <div className="col-2 text-end">
          { filter[slider.attribute] }
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="row align-items-center">
        <div className="col-8">
          <h3 className='title mb-0'>{filter.name}</h3>
        </div>
        <div className="col-4 text-end">
          <button
            type="button"
            className="btn btn-dark btn-sm skip"
            onClick={handleCopyClick}
          >
            Copy
          </button>

        </div>
      </div>
      <hr className='mb-0' />
      <div className="row sliders">
        <div className="col-lg-6 col-md-12">
          { SLIDERS.map((slider, index) => {
              return renderSlider(slider, index)
            })
          }
        </div>
        <div className="col-lg-6 col-md-12">
          { ADJUSTMENT_SLIDERS.map((slider, index) => {
              return renderSlider(slider, index)
            })
          }
        </div>
      </div>
    </>
  )
}

export default FilterEditor
